import axios from '../../axios/index.js'

export default {
  list(data) {
    return axios.get('get_active_clients',{ params:data });
  },

  listToEhsSelect() {
    return axios.get('get_active_clients_to_ehs');
  },

  getList(data) {
    return axios.get('clients/list',{ params:data });
  },

  getCompanies() {
    return axios.get('clients/get_companies');
  },

  getZones() {
    return axios.get('clients/facilities/getZones');
  },

  getCompany(id) {
    return axios.get('clients/company/' + id);
  },

  checkCompany(data) {
    return axios.post('clients/companies/check', data);
  },

  checkHeadquarter(data) {
    return axios.post('clients/headquarter/check', data);
  },

  checkClient(data) {
    return axios.post('clients/check', data);
  },

  add(data) {
    return axios.post('get_active_clients', data);
  },

  getClientDetails(id) {
    return axios.get('clients/detail/' + id);
  },

  getClientFacilities(id) {
    return axios.get('clients/facilities/' + id);
  },

  getClientHeadquarter(id) {
    return axios.get('clients/headquarter/' + id);
  },

  getClientRates(id) {
    return axios.get('clients/rates/' + id);
  },

  addFacility(data) {
    return axios.post('clients/facility/store', data);
  },

  addRate(data) {
    return axios.post('clients/rate/store', data);
  },

  updateClient(id, data) {
    return axios.post('clients/update/' + id, data);
  },

  updateFacility(id,data) {
    return axios.post('clients/update_facility/' + id,data);
  },

  updateHeadquarter(id, data) {
    return axios.post('clients/update_headquarter/' + id, data);
  },

  updateRate(id,data) {
    return axios.post('clients/update_rate/'+ id,data);
  },
  storeClient(data) {
    return axios.post('/clients/store',data)
  },
  lock(data){
    return axios.post('/clients/lock',data)
  },
  getDocuments(id) {
    return axios.get('clients/getDocuments/' + id );
  },
  updateDocuments(id, data) {
    return axios.post('clients/documents/' + id, data);
  },
  
}
